import React, {useContext, useEffect, useRef, useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {UserService} from "../services/UserService";
import {Toast} from "primereact/toast";
import {Fieldset} from "primereact/fieldset";
import {Panel} from "primereact/panel";
import {AuthContext} from "../App";
import {Button} from "primereact/button";
import {TriStateCheckbox} from "primereact/tristatecheckbox";
import {useFormik} from "formik";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";


// The rule argument should be a string in the format "custom_[field]".

export default function GeneratedPlaylist({ nrAddedPlaylists }) {
    const [generatedPlaylists, setGeneratedPlaylists] = useState([]);
    const [plApp, setPlApp] = useState(false);
    const userservice = new UserService();
    const toast = useRef(null);
    const auth = useContext(AuthContext);

    useEffect(() => {
        if(auth.isAuthenticated()) {
            userservice.getGeneratedPlaylists(auth.getAccessToken()).then((resp) => {
                if (resp.status === 200) {
                    resp.json().then((data) => {
                        setGeneratedPlaylists(data)
                    })
                } else {
                    setGeneratedPlaylists([]);
                    if (resp.status === 401) {
                        console.log("hallo")

                        toast.current.show({
                            severity: 'error',
                            summary: 'Not authorized',
                            detail: 'Please, log in.',
                            life: 6000
                        })
                    } else {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Data could not be retrieved',
                            detail: 'Please, try again!',
                            life: 6000
                        })
                    }
                }
            })
        }else {
            toast.current.show({severity: 'warning', summary: 'Not authenticated'})
        }
    }, [auth, nrAddedPlaylists]);

    const formik = useFormik({
        initialValues: {
            name: "",
            description: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.name) {
                errors.name = 'Name is required';
            }
            if(!data.description) {
                errors.description = 'Description is required';
            }

            return errors;
        },
        onSubmit: (data) => {
            if(data.id){
                userservice.updateGeneratedPlaylist(data, auth.getAccessToken()).then((res) => {
                    if(res.status === 200) {
                        res.json().then(data => {
                            onSaveGeneratedPlaylist(data);
                            formik.resetForm();
                        })
                    }
                    else
                    {
                        console.error("something went wrong");
                    }
                })
            } else {
                console.error("something went wrong");
            }
        }
    });

    function onSaveGeneratedPlaylist(data){
        let _generatedPlaylist = generatedPlaylists;
        let i = findIndexById(data.id);
        _generatedPlaylist[i] = data;
        setGeneratedPlaylists(_generatedPlaylist);
        setPlApp(false);
    }

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < generatedPlaylists.length; i++) {
            if (generatedPlaylists[i].id === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    function handleDeletePlaylist(plinfo) {
        userservice.removeGeneratedPlaylist(auth.getAccessToken(), plinfo.spotify_id).then((resp) => {
            if (resp.status === 200) {
                plinfo.is_active = false;
                onSaveGeneratedPlaylist(plinfo);
                toast.current.show({severity: 'success', summary: "Playlist removed from spotify profile.", life: 6000});
            } else {
                toast.current.show({severity: 'error', summary: 'Playlist could not be removed from spotify profile.', life: 6000});
            }
        })
    }

    function openNewTab(url){
        let win = window.open(url, '_blank');
        win.focus();
    }

    function openInThisWindow(url){
        let win = window.open(url, '_self');
        win.focus();
    }

    const linkBodyTemplate = (plinfo) => {
        return <div>
            <Button icon="pi pi-external-link" className="p-button-rounded bg-spot" aria-label="OpenPlaylistNewWindow" onClick={() => openNewTab('https://open.spotify.com/playlist/' + plinfo.spotify_id)} label={"Spotify"}/>
             </div>;
    };

    const isactiveBodyTemplate = (plinfo) => {
        return <div>
            {plinfo.is_active ? <i className="pi pi-check mr-3"></i> : <i className="pi pi-times mr-3"></i>}
            <Button visible={plinfo.is_active} icon="pi pi-trash" className="p-button-rounded p-button-error" aria-label="DeleteFromPublicProfile" onClick={() => handleDeletePlaylist(plinfo)}></Button>
        </div>
    }

    const hideDialog = () => {
        setPlApp(false);

    }

    function editPl(rowData) {
        setPlApp(true);
        formik.setValues(rowData);
        //setUpdatePL(rowData);
    }

    const actionBodyTemplate = (rowData) => {
        return <div>
            <Button icon={"pi pi-pencil"} className={"p-button-rounded"} onClick={() => editPl(rowData)}/>
        </div>
    }
    // in case I want to add filter for is_visible
    const verifiedRowFilterTemplate = (options) => {
        return <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />;
    };

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    //<div>Since logging in the last time, you generated {nrAddedPlaylists} playlist/s</div>


    return (
        <div>
        <Toast ref={toast}/>
        <Panel header="Playlists" toggleable collapsed={false}>
            <Fieldset className={"p-0"} legend={"Playlists Generated by " + auth.currentUser?.username }>
                <div className="card-controls">
                    <div>
                        <DataTable value={generatedPlaylists}>
                            <Column field="name" header="Name" sortable></Column>
                            <Column field="description" header="Description" sortable></Column>
                            <Column field="spotify_id" header="Link" body={linkBodyTemplate}></Column>
                            <Column field="is_active" header="Public" headerTooltip={"Visible in public profile"}  body={isactiveBodyTemplate}
                                    sortable dataType="boolean"></Column>
                            <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '2rem' }}></Column>
                        </DataTable>
                    </div>
                    <Dialog visible={plApp} style={{ width: '450px' }} header="Edit Playlist" modal className="p-fluid" onHide={hideDialog}>
                        <div className="flex justify-content-center">
                            <div className="card">
                                <form onSubmit={formik.handleSubmit} className="p-fluid">

                                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="name" name="name" value={formik.values.name} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('name') })} />
                            <label htmlFor="name" className={classNames({ 'p-error': isFormFieldValid('name') })}>Name</label>
                        </span>
                                        {getFormErrorMessage('name')}
                                    </div>

                                    <div className="field">
                        <span className="p-float-label">
                            <InputText id="description" name="description" value={formik.values.description} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('description') })} />
                            <label htmlFor="description" className={classNames({ 'p-error': isFormFieldValid('description') })}>Description</label>
                        </span>
                                        {getFormErrorMessage('description')}
                                    </div>

                                    <Button type="submit" label={"Update"} className="mt-2"/>

                                </form>
                                <Button type="Button" style={{textAlign: "left"}} text iconPos={"left"}  icon={"pi pi-file-edit"} label={"Edit in Editor"} onClick={() => {openInThisWindow("/editor/"+formik.values.spotify_id)}} className="mt-2"/>
                                <Button type="Button" style={{textAlign: "left"}} text iconPos="left" icon={"pi pi-list"} label={"Use as Input for Generator"} onClick={() => {openInThisWindow("/playlist/"+formik.values.spotify_id)}} className="mt-2"/>
                                 </div>
                        </div>
                    </Dialog>
                </div>
            </Fieldset>
            {/*<Fieldset className={"p-0"} legend={"Playlist Finder"}>*/}
            {/*    Todo find playlists*/}
            {/*</Fieldset>*/}
        </Panel>
        </div>
    )
}